export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getPropertyCodes: function getPropertyCodes(lob, jobNumber, previousClassCode, address, sessionUUID) {
            return JsonRPCService.send('propertycode', 'propertycode', 'getPropertyCodes', [lob, jobNumber, previousClassCode, address, sessionUUID]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/common/services/PropertyCodeLookupService.js
// module id = 2138
// module chunks = 0